/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Activity_ReplantingInputs */

const vi_care_log_activity_replanting = /** @type {(inputs: Care_Log_Activity_ReplantingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trồng dặm`)
};

/**

* @param {Care_Log_Activity_ReplantingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_activity_replanting = /** @type {((inputs?: Care_Log_Activity_ReplantingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Activity_ReplantingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_activity_replanting(inputs)
});